import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Sections/Menu.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.17_@babel+core@7.26.9_react-dom@18.3.1_react@18.3.1_sass@1.85.0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/.pnpm/sonner@1.7.4_react-dom@18.3.1_react@18.3.1/node_modules/sonner/dist/index.mjs");
